<template>
  <div class="infoPage">
    <div class="infoHeader">
      <font-awesome-icon icon="link" class="w3-right headerIcon" /><h2>{{ $t('info.linkingAccount.header')}}</h2>
    </div>
    <div class="infoText">   
      <p>{{ $t('info.linkingAccount.intro')}}</p>
      <ul>
        <li>
          <b>{{ $t('info.linkingAccount.advantage1Title')}}</b>
          <p>{{ $t('info.linkingAccount.advantage1Text')}}</p>
        </li>
        <li>
          <b>{{ $t('info.linkingAccount.advantage2Title')}}</b>
          <p>{{ $t('info.linkingAccount.advantage2Text')}}</p>
        </li>
        <li>
          <b>{{ $t('info.linkingAccount.advantage3Title')}}</b>
          <p>{{ $t('info.linkingAccount.advantage3Text')}}</p>
        </li>
      </ul>
    </div>
    <h6><router-link :to="'/select-user/'" class="imgbtn" title="link account"><font-awesome-icon icon="link" /> {{ $t('info.linkingAccount.yesIWill')}}</router-link></h6>
    <h6><router-link :to="'/'" class="imgbtn" title="link account"><font-awesome-icon icon="times" /> {{ $t('info.linkingAccount.maybeNextTime')}}</router-link></h6>
  </div>
</template>

<script>
export default {
  name: 'InfoLinkingAccount',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  text-decoration: none;
}

h6 {
  margin-left: 8px;
}

.imgbtn {
  float: right;
  border: 1px solid #333333;
  border-radius: 2px;
  color: #8fabd6;
}

.imgbtn:hover {
  color: #365c96;
}

</style>
